<template>
  <div class="contenter">
    <div class="top-step">
      <div class="sub-title">售后申请单</div>
      <after-sale-step :afterSaleOrder="orderData"></after-sale-step>
    </div>
    <div class="main-contenter">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="售后单信息" name="first">
          <afterSaleInfo
            ref="afterSale"
            :isCreat="isCreat"
            :orderData="orderData"
            :devId="devId"
          ></afterSaleInfo>
          <afterSalePlan
            v-if="!(isCreat || orderData.status === dictMap['cancelled'].id)"
            ref="afterSalePlan"
            :orderData="orderData"
          ></afterSalePlan>
          <editOrderLog
            :afterSaleOrder="orderData"
            v-if="[dictMap['cancelled'].id].includes(orderData.status)"
          ></editOrderLog>
        </el-tab-pane>
        <el-tab-pane label="收发货信息" name="second">
          <recandPost
            ref="recandPost"
            :orderData="orderData"
            :isCreat="isCreat"
          ></recandPost>
        </el-tab-pane>
        <el-tab-pane
          label="检测/维修"
          name="third"
          v-if="!(isCreat || orderData.status === dictMap['cancelled'].id)"
        >
          <insandRepair
            ref="insandRepairInfo"
            :orderData="orderData"
          ></insandRepair>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="bottom-btn">
      <el-button type="info" @click="goBack" v-if="isCreat">取消</el-button>
      <el-button type="info" @click="goBack" v-else>返回</el-button>
      <el-button
        v-if="
          orderData.status ===
            dictMap['pre_inspection_of_receiving_goods'].id &&
          userIn.id == orderData.creator
        "
        v-permission="'concole_after_sales'"
        class="console-btn"
        @click="submit(2)"
        >取消申请</el-button
      >
      <el-button
        type="primary"
        class="submit-btn"
        @click="submit"
        v-if="getPermission()"
        >{{ submitText() }}</el-button
      >
    </div>
    <conDialog
      :contentText="dialogContentText"
      :isShow="centerDialogVisible"
      :title="dialogTitle"
      @conform="confirmSubmit"
      @cancel="centerDialogVisible = false"
    ></conDialog>
    <el-dialog
      title="取消售后单"
      :visible.sync="isShowConOrder"
      width="30%"
      center
      :show-close="false"
      top="38vh"
    >
      <div class="">
        <el-form
          ref="form"
          :model="consoleInfo"
          label-width="80px"
          label-position="top"
        >
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="请选择取消售后单原因" prop="category">
                <el-select
                  clearable
                  v-model="consoleInfo.reason"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in cancelAfterSalesOrderList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="其他原因" prop="category">
              <el-input
                v-model="consoleInfo.description"
                type="textarea"
                placeholder="请输入其他原因，限制200字符。"
                :rows="2"
                maxlength="200"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowConOrder = false">取 消</el-button>
        <el-button class="dialog-footer-btn" @click="confirmSubmit(2)"
          >确认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import afterSaleInfo from "./components/afterSaleInfo.vue";
import recandPost from "./components/reciveandPostInfo.vue";
import afterSalePlan from "./components/afterSalePlan.vue";
import insandRepair from "./components/insandRepair.vue";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import conDialog from "@/components/dialog.vue";
dayjs.extend(duration);
import { getDictMap } from "../../utils/util";
import AfterSaleStep from "./components/afterSaleStep.vue";
import editOrderLog from "./components/editOrderLog.vue";
export default {
  components: {
    afterSaleInfo,
    recandPost,
    afterSalePlan,
    insandRepair,
    conDialog,
    AfterSaleStep,
    editOrderLog,
  },
  data() {
    return {
      isShowConOrder: false,
      dialogTitle: "提示",
      dialogContentText: "确定要提交吗",
      centerDialogVisible: false,
      isCreat: false,
      orderParams: {},
      active: 0,
      activeName: "first", //展示的模块位置
      typeValue: "",
      orderData: {},
      orderStatusList: [],
      cancelAfterSalesOrderList: [],
      textStatus: ["提交售后单", "收货预检", "待审核", "维修中", "待寄出"],
      statusList: ["1", "2", "3", "4", "5"],
      descList: [],
      userIn: {},
      consoleInfo: {
        reason: "",
        description: "",
      },
      curOrderId: "",
      dictMap: {},
      devId: "",
    };
  },
  created() {
    this.userIn = JSON.parse(localStorage.getItem("userInfo"));
    this.dictMap = getDictMap();
  },
  beforeMount() {
    console.log("this.query", this.$route.query);
    if (this.$route.query.isCreat) {
      this.isCreat = true;
    }
    if (this.$route.query.devId) {
      // this.getDevDetail(devId);
      this.devId = this.$route.query.devId;
    }
  },
  mounted() {
    this.getDict();
    this.getOrderInfo();
  },
  methods: {
    getPermission() {
      //数组中的状态不展示提交按钮
      const excludedStatuses = [
        this.dictMap["sent_out"].id, // 已寄出
        this.dictMap["cancelled"].id, // 已取消
        this.dictMap["returned_inventory"].id, // 已退货
        this.dictMap["returned"].id, // 已退回
      ];

      // 如果订单状态在排除列表中，直接返回 false
      if (excludedStatuses.includes(this.orderData.status)) return false;
      if (this.isCreat && this.$jumpPerm("creat_after_sales")) return true;
      // 权限和状态映射关系  (权限码code:字典项code)
      const permissionMap = {
        recive_pre_check: "pre_inspection_of_receiving_goods", // 收货预检
        audit: "pending_review", // 待审核
        repair: "under_repair", // 维修中
        return: "to_be_returned", // 待退回
        send: "to_be_sent_out", // 待寄出
      };

      // 遍历权限映射，检查当前状态和权限是否匹配
      return Object.entries(permissionMap).some(
        ([permCode, statusKey]) =>
          this.$jumpPerm(permCode) &&
          this.orderData.status === this.dictMap[statusKey].id
      );
    },
    submitText() {
      switch (this.orderData.status) {
        case this.dictMap["to_be_returned"]?.id:
          return "退回";
        case this.dictMap["under_repair"]?.id:
          return "完成维修";
        case this.dictMap["to_be_sent_out"]?.id:
          return "寄出";
        default:
          return "提交";
      }
    },
    confirmSubmit(type) {
      this.centerDialogVisible = false;
      this.isShowConOrder = false;
      if (type === 2) {
        this.orderParams = {
          ...this.orderParams,
          ...this.consoleInfo,
          afterSalesSolution: "",
        };
      }
      if (this.isCreat) {
        // console.log("新建售后单参数this.orderParams", this.orderParams);
        // return;
        this.$post("/aftersales/order/add", this.orderParams).then((res) => {
          if (res.data.code === 1000) {
            this.curOrderId = res.data.data.id;
            this.activeName = "first";
            this.isCreat = false;
            this.active = 1;
            this.getOrderInfo(res.data.data.id);
            this.$router.push({
              path: "/afterSaleOrder",
              query: {
                id: res.data.data.id,
              },
            });
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
      } else {
        // console.log("编辑售后单参数this.orderParams", this.orderParams);
        // return;
        this.$post("/aftersales/order/edit", this.orderParams).then((res) => {
          if (res.data.code === 1000) {
            this.activeName = "first";
            this.getOrderInfo(this.curOrderId);
          } else {
            this.$message({
              type: "error",
              message: this.$message({
                type: "error",
                message: res.data.msg,
              }),
            });
          }
        });
      }
    },
    submit(num) {
      this.centerDialogVisible = false;
      // console.log("售后单信息userInfo", this.$refs.afterSale.userInfo);
      // console.log("this.$refs.recandPost", this.$refs.recandPost.receivedInfo);
      // console.log(
      //   "this.$refs.recandPost.shippedInfo;",
      //   this.$refs.recandPost.shippedInfo
      // );
      // console.log("检测/维修info", this.$refs.insandRepairInfo?.info);
      // console.log("afterSalePlan==", this.$refs.afterSalePlan?.info);

      const afterSaleInfo = this.$refs.afterSale.userInfo; //售后单信息
      const receivedInfo = this.$refs.recandPost.receivedInfo; //寄回信息
      const shippedInfo = this.$refs.recandPost.shippedInfo; //发货信息
      const insandRepairInfo = this.$refs.insandRepairInfo?.info; //检测维修信息
      const afterSalePlan = this.$refs.afterSalePlan?.info; //售后方案

      let params = {
        ...receivedInfo,
        ...shippedInfo,
        ...afterSaleInfo,
        ...insandRepairInfo,
        ...afterSalePlan,
        attachment: afterSaleInfo.attachment,
        // attachmentList: [],
      };
      if (num === 2) {
        //取消订单
        // console.log("params==num", params);
        this.orderParams = params;
        this.isShowConOrder = true;
        return;
      }
      if (
        receivedInfo?.receivedStatus ===
          this.dictMap["not_received_goods"]?.id &&
        !this.isCreat
      ) {
        this.activeName = "second";
        this.$message({
          type: "error",
          message: "物流状态需变更为已收货才可提交",
        });
        return;
      }
      if (
        afterSalePlan?.afterSalesSolution === this.dictMap["repair"]?.id &&
        insandRepairInfo.equipmentStatus ===
          this.dictMap["damaged_and_scrapped"]?.id
      ) {
        this.activeName = "third";
        this.$message({
          type: "error",
          message: "设备报废不支持维修，请重新选择",
        });
        return;
      }
      if (params.status !== this.dictMap["pending_review"]?.id) {
        params.exchangeSolution = "";
      }
      let afterSale = ["category", "problemDescription", "coding"];
      let salePlan = [];
      if (
        afterSalePlan?.afterSalesSolution ===
          this.dictMap["exchange_goods"]?.id &&
        params.status === this.dictMap["pre_inspection_of_receiving_goods"]?.id
      ) {
        //售后方案为换货
        salePlan = ["description"];
      } else if (
        afterSalePlan?.afterSalesSolution ===
          this.dictMap["goods_return"]?.id &&
        params.status === this.dictMap["pre_inspection_of_receiving_goods"]?.id
      ) {
        //售后方案为退回
        if (params.reason === this.dictMap["reason_for_refund_other"]?.id) {
          salePlan = ["reason", "description"];
        } else {
          salePlan = ["reason"];
        }
      } else if (
        afterSalePlan?.afterSalesSolution ===
          this.dictMap["exchange_goods"]?.id &&
        afterSalePlan?.exchangeSolution ===
          this.dictMap["agree_exchange"]?.id &&
        params.status === this.dictMap["to_be_sent_out"]?.id
      ) {
        //同意换货校验设备gdid
        salePlan = ["exchangeGdid"];
      } else if (
        afterSalePlan?.afterSalesSolution ===
          this.dictMap["exchange_goods"]?.id &&
        afterSalePlan?.exchangeSolution ===
          this.dictMap["reject_exchange"]?.id &&
        this.orderData.status === this.dictMap["pending_review"]?.id
      ) {
        //方案为换货但是拒绝换货
        salePlan = ["reason"];
        if (
          afterSalePlan.reason ===
          this.dictMap["reason_for_refusing_exchange_other"]?.id
        ) {
          salePlan = ["reason", "description"];
        }
        // salePlan = ["reason", "description"];
      } else {
        salePlan = [];
      }
      if (
        afterSalePlan?.afterSalesSolution ===
          this.dictMap["reject_return"]?.id &&
        this.orderData.status ===
          this.dictMap["pre_inspection_of_receiving_goods"]?.id
      ) {
        salePlan = ["reason"];
        if (
          afterSalePlan.reason ===
          this.dictMap["reason_for_refusal_of_return_other"]?.id
        ) {
          salePlan = ["reason", "description"];
        }
      } else {
        salePlan = [];
      }
      // console.log("salePlan==", salePlan);

      let recandShip = [
        "receivedStatus",
        // "receivedMethod",
        "receivedCustomerA",
        "receivedCustomerB",
        // "receivedRemarks",
      ];

      if (
        [
          this.dictMap["to_be_sent_out"].id,
          this.dictMap["to_be_returned"].id,
        ].includes(params.status)
      ) {
        recandShip = [
          "receivedStatus",
          "receivedMethod",
          "receivedCustomerA",
          "receivedCustomerB",
          // "receivedRemarks",
          "shippedStatus",
          "shippedMethod",
          "shippedCustomerA",
          "shippedCustomerB",
          // "shippedRemarks",
        ];
      } else {
        //新建售后单校验的收发货信息
        recandShip = [
          "receivedStatus",
          "receivedMethod",
          // "receivedCustomerA",
          // "receivedCustomerB",
          // "receivedRemarks",
        ];
      }
      if (
        this.isCreat &&
        receivedInfo?.receivedStatus === this.dictMap["not_received_goods"]?.id
      ) {
        recandShip = [
          "receivedStatus",
          // "receivedMethod",
          // "receivedCustomerA",
          // "receivedCustomerB",
          // "receivedRemarks",
        ];
      }
      let insandRepair = ["equipmentStatus", "testResultDescription"];
      if (
        insandRepairInfo &&
        insandRepairInfo.equipmentStatus ===
          this.dictMap["damaged_and_in_need_of_repair"]?.id &&
        this.orderData.status === this.dictMap["under_repair"].id
      ) {
        insandRepair = [
          "equipmentStatus",
          "testResultDescription",
          "repairMethod",
          "repairContentDescription",
        ];
      }
      if (this.isCreat) {
        if (
          afterSaleInfo.problemDescription &&
          afterSaleInfo.problemDescription.length < 4
        ) {
          //校验问题描述长度
          this.$message({
            type: "error",
            message: "问题描述限制4-200字符",
          });
          this.activeName = "first";
          return;
        }
        if (!this.validate(afterSale, params)) {
          this.activeName = "first";

          this.$message({
            type: "error",
            message: "请将必填项填写完整",
          });
        } else if (!this.validate(recandShip, params)) {
          this.activeName = "second";
          this.$message({
            type: "error",
            message: "未完善设备快递信息",
          });
        } else {
          // console.log("params==", params);
          this.orderParams = params;
          this.dialogTitle = "确认提交";
          this.dialogContentText = "确认提交售后单";
          this.centerDialogVisible = true;
        }
      } else {
        if (
          !insandRepairInfo.testResultDescription ||
          insandRepairInfo.testResultDescription.length < 4
        ) {
          this.$message({
            type: "error",
            message: "请完善检测结果描述，限制4-200字符",
          });
          this.activeName = "third";
          return;
        }
        if (!this.validate(salePlan, params)) {
          this.activeName = "first";
          // console.log("salePlan==", salePlan);

          this.$message({
            type: "error",
            message: "请将必填项填写完整",
          });
        } else if (!this.validate(recandShip, params)) {
          this.activeName = "second";
          this.$message({
            type: "error",
            message: "请将必填项填写完整",
          });
        } else if (!this.validate(insandRepair, params)) {
          this.activeName = "third";

          this.$message({
            type: "error",
            message: "请完善检测/维修信息",
          });
        } else {
          // console.log("params++", params);
          this.orderParams = params;
          if (params.afterSalesSolution === this.dictMap["repair"]?.id) {
            this.dialogTitle = "确认维修";
            this.dialogContentText = "确认维修设备";
          } else if (
            params.afterSalesSolution === this.dictMap["exchange_goods"]?.id
          ) {
            this.dialogTitle = "确认换货";
            this.dialogContentText = "确认更换新设备";
          } else if (
            params.afterSalesSolution === this.dictMap["goods_return"]?.id
          ) {
            this.dialogTitle = "确认退回";
            this.dialogContentText = "确认退回设备";
          }
          if (
            params.afterSalesSolution === this.dictMap["exchange_goods"]?.id &&
            params.exchangeSolution === this.dictMap["agree_exchange"]?.id
          ) {
            this.dialogTitle = "确认换货";
            this.dialogContentText = "确认为用户换货";
          }
          if (params.afterSalesSolution === this.dictMap["agree_return"]?.id) {
            this.dialogTitle = "确认退货";
            this.dialogContentText = "确认为用户退货";
          } else if (
            params.afterSalesSolution === this.dictMap["reject_return"]?.id
          ) {
            this.dialogTitle = "确认拒绝退货";
            this.dialogContentText = "确认拒绝退货";
          } else if (
            params.afterSalesSolution === this.dictMap["exchange_goods"]?.id &&
            params.exchangeSolution === this.dictMap["reject_exchange"]?.id
          ) {
            this.dialogTitle = "确认拒绝换货";
            this.dialogContentText = "确认拒绝换货";
          }

          if (params.status === this.dictMap["to_be_sent_out"]?.id) {
            this.dialogTitle = "确认寄出";
            this.dialogContentText = "确认设备已寄出";
          } else if (params.status === this.dictMap["to_be_returned"]?.id) {
            this.dialogTitle = "确认退回";
            this.dialogContentText = "确认设备已退回";
          }
          this.centerDialogVisible = true;
          // if (
          //   afterSalePlan?.exchangeSolution !==
          //   this.dictMap["reject_exchange"]?.id
          // ) {
          //   this.centerDialogVisible = true;
          // } else {
          //   this.confirmSubmit();
          // }
        }
      }
    },
    calTime(startTime, endTime) {
      //计算时间差值
      const start = dayjs(startTime);
      const end = dayjs(endTime);

      // 计算差值（以毫秒为单位）
      const diffInMilliseconds = end.diff(start);

      // 将毫秒转换为小时和分钟
      const duration = dayjs.duration(diffInMilliseconds);
      const hours = Math.floor(duration.asHours());
      const minutes = duration.minutes();

      // 返回时间差字符串
      // console.log("时间差字符串", `${hours}小时${minutes}分钟`);

      return `${hours}小时${minutes}分钟`;
    },
    getPopName(item) {
      // console.log("item", item);
      if (item.id === this.dictMap["pending_review"]?.id) {
        return (item.creatorName = "系统流程");
      } else {
        return item.creatorName;
      }
    },
    handDate(date) {
      if (date) {
        return date.slice(0, 16);
      } else {
        return null;
      }
    },
    goBack() {
      // this.$router.back();
      this.$router.replace({ path: "/aftersalemanage" });
    },
    getDict() {
      // this.orderStatusList = findDictItem("process_status").children;
      this.orderStatusList = this.dictMap["process_status"]?.children;
      this.statusList = this.getStepStatusList(this.textStatus);
      // console.log("this.statusList==", this.statusList);
      // this.cancelAfterSalesOrderList = findDictItem(
      //   "cancel_after_sales_order"
      // ).children;
      this.cancelAfterSalesOrderList =
        this.dictMap["cancel_after_sales_order"]?.children;
    },
    getStepStatusList(textStatus) {
      return textStatus.map((status) => {
        let it = this.orderStatusList.find((item) => item.name === status);
        return this.orderStatusList.find((item) => item.name === status);
      });
    },
    getOrderInfo(_id) {
      let id = this.$route.query.id;
      if (!id) {
        id = _id;
      }
      if (id) {
        this.$get("/aftersales/order/info", { id }).then((res) => {
          if (res.data.code == 1000) {
            const data = res.data.data;
            this.orderData = data;
            // console.log("this.orderData", this.orderData);

            if (
              data.status ===
              this.dictMap["pre_inspection_of_receiving_goods"]?.id
            ) {
              //收货预检
              this.active = 1;
            } else if (data.status === this.dictMap["pending_review"]?.id) {
              //待审核
              this.active = 2;
            } else if (data.status === this.dictMap["under_repair"]?.id) {
              //维修中
              this.active = 3;
            } else if (data.status === this.dictMap["to_be_sent_out"]?.id) {
              //待寄出
              this.active = 4;
            } else if (data.status === this.dictMap["sent_out"]?.id) {
              //已寄出
              this.active = 4;
              this.textStatus = [
                "提交售后单",
                "收货预检",
                "待审核",
                "维修中",
                "已寄出",
              ];
            } else if (data.status === this.dictMap["to_be_returned"]?.id) {
              //待退回
              this.active = 4;
              this.textStatus = [
                "提交售后单",
                "收货预检",
                "待审核",
                "维修中",
                "待退回",
              ];
            } else if (data.status === this.dictMap["returned"]?.id) {
              //已退回
              this.active = 4;
              this.textStatus = [
                "提交售后单",
                "收货预检",
                "待审核",
                "维修中",
                "已退回",
              ];
            }

            // console.log("this.textStatus==", this.textStatus);

            if (data?.statusLog.length > 0) {
              const statusMap = new Map(
                this.statusList.map((item) => [item.id, item])
              );

              // 遍历状态日志
              for (let index = 0; index < data.statusLog.length; index++) {
                const log = data.statusLog[index];
                const statusItem = statusMap.get(log.statusFrom);

                if (statusItem) {
                  // 更新 creatorName 和 createdAt
                  statusItem.creatorName = log.creatorName;
                  statusItem.createdAt = log.createdAt;

                  // 计算 dealTime 如果不是第一个元素
                  if (index > 0) {
                    const previousLog = data.statusLog[index - 1];
                    const previousStatusItem = statusMap.get(
                      previousLog.statusFrom
                    );
                    if (previousStatusItem) {
                      const time = this.calTime(
                        previousStatusItem.createdAt,
                        statusItem.createdAt
                      );
                      statusItem.dealTime = time; // 当前元素添加 dealTime 属性
                    }
                  }
                }
              }
            }

            this.statusList = this.getStepStatusList(this.textStatus);
            // console.log("this.statusList----", this.statusList);
          }
          if (this.orderData.status === this.dictMap["under_repair"].id) {
            setTimeout(() => {//上传文件组件中的视频文件替换为视频图片
              this.$refs?.insandRepairInfo?.$refs?.uploadFile1?.initImgandVideo();
              this.$refs?.insandRepairInfo?.$refs?.uploadFile2?.initImgandVideo();
            }, 500);
          }
        });
      }
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    validate(requiredFields, userinfo) {
      //校验必填项
      const validationErrors = [];
      requiredFields.forEach((field) => {
        if (!userinfo[field]) {
          validationErrors.push(`${field} 是必填项`);
        }
      });

      return validationErrors.length === 0; // 返回是否通过验证
    },
  },
};
</script>

<style lang="less" scoped>
.sub-title {
  font-weight: 500;
  font-size: 16px;
  color: #1d2129;
  margin-bottom: 40px;
}
.step-space {
  padding-bottom: 20px;
}
::v-deep .el-step__icon {
  border: none !important;
  background-color: #f2f3f5;
  width: 28px;
  height: 28px;
}
::v-deep .el-step__icon-inner {
  font-weight: 600;
  font-size: 16px;
  color: #4e5969;
}
::v-deep .is-process {
  .num {
    color: #fff;
  }
  .el-step__icon {
    background-color: #165dff;
  }
  .el-step__icon-inner {
    color: #fff;
  }
}
::v-deep .el-step__line {
  top: 13px !important;
  left: 60% !important;
  right: -40% !important;
  height: 1px !important;
  background-color: #e5e6eb;
}
::v-deep .is-finish {
  .el-step__icon {
    background-color: #e8f3ff;
  }
  .el-step__line {
    background-color: #165dff;
  }
  .el-step__line-inner {
    border: none;
  }
}
::v-deep .el-step__title.is-finish {
  font-weight: 500;
  font-size: 16px;
  color: #1d2129;
  width: 100%;
}
::v-deep .el-step.is-center .el-step__description {
  font-weight: 400;
  font-size: 12px;
  color: #86909c;
  // text-align: left;
  // padding-left: 36%;
  // padding-right: 36%;
  // width: 100%;
}
::v-deep .el-step__title.is-wait {
  font-weight: 400;
  font-size: 16px;
  color: #4e5969;
}
::v-deep .is-wait {
  .num {
    color: #4e5969;
  }
}
::v-deep .el-step__title.is-process {
  font-weight: 500;
  color: #1d2129;
}
::v-deep .el-step__description.is-process {
  font-weight: 400;
  font-size: 12px;
  color: #86909c;
}

.cus-icon {
  display: flex;
  align-items: center;
  img {
    vertical-align: middle;
  }
}
.contenter {
  // padding: 20px 20px 0;
  box-sizing: border-box;
}
::v-deep .el-table .el-table__row:hover > td {
  background-color: transparent !important; /* 取消默认的 hover 背景色 */
}
.top-step {
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 20px;
}
.main-contenter {
  background-color: #fff;
  padding: 20px 20px 35px;
  // height: 100%;
}
::v-deep .main-content {
  padding: 16px 16px 0 !important;
}
::v-deep .el-main {
  padding-bottom: 0 !important;
}
.bottom-btn {
  background-color: #fff;
  width: 100%;
  height: 56px;
  position: sticky;
  bottom: -20px;
  z-index: 2000;
  box-shadow: 0px -4px 10px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 40px;
  box-sizing: border-box;
  .el-button {
    // width: 60px;
    height: 32px;
    background: #f2f3f5;
    border-radius: 2px 2px 2px 2px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .console-btn {
    background-color: #f53f3f;
    color: #fff;
    width: 80px;
  }
  .submit-btn {
    display: flex;
    padding: 5px 16px;
  }
}
::v-deep .el-tabs__nav-wrap::after {
  display: none;
}
::v-deep .el-tabs__item.is-active {
  color: #165dff;
}
::v-deep .el-tabs__item:hover {
  color: #165dff;
}
::v-deep .el-tabs__active-bar {
  background-color: #165dff;
}
.pop-content {
  .pop-content-top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    .pop-name {
      font-weight: 400;
      font-size: 14px;
      color: #1d2129;
    }
  }
  .pop-content-bottom {
    font-weight: 400;
    font-size: 12px;
    color: #86909c;
  }
}
.pop-status {
  display: flex;
  align-items: center;
}
.deal-status {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #00b42a;
  margin-right: 8px;
}
::v-deep .el-textarea {
  .el-textarea__inner {
    //background: #f2f3f5;
    // border: none;
  }
}
::v-deep .el-input__count {
  line-height: 12px;
  //background: #f2f3f5 !important;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  .el-button {
    width: 60px;
    height: 32px;
    border-radius: 2px;
    background-color: #f2f3f5;
    font-weight: 400;
    font-size: 14px;
    color: #4e5969;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .dialog-footer-btn {
    background-color: #165dff;
    color: #ffffff;
    width: 80px;
  }
}
</style>
